import { Component, OnInit, Input } from '@angular/core';
import { StatementMonthRequirement } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { monthValueToFormattedMonth } from 'ng2-app/modules/shared/functions/strings';
import { environment } from 'environments/environment';

@Component({
    selector: 'month-requirement',
    templateUrl: 'month-requirement.component.html',
    styleUrls: ['month-requirement.component.scss']
})
export class MonthRequirementComponent implements OnInit {

    @Input() requirement: StatementMonthRequirement;
    @Input() borrowerId: number;

    constructor() {}

    ngOnInit() {
    }

    openDocument(documentId: number) {
        if (!this.docIsClean) {
            return;
        }

        const url = `${environment.API_URL}/document/${documentId}?stream=1`;
        window.open(url, '_blank');
    }

    formattedMonth(month: string) {
        return monthValueToFormattedMonth(month);
    }

    formattedStatus(status: string) {
        return status.charAt(0).toUpperCase() + status.slice(1);
    }

    get viewHref() {
        return this.docIsClean ? '#' : null;
    }

    get viewTitle() {
        if (this.docIsInfected) {
            return 'Infected';
        }
        if (!this.docIsScanned) {
            return 'Scanning...';
        }
        return null;
    }

    get docIsScanned() {
        return this.requirement.documentId
            && this.requirement.documentScanned;
    }

    get docIsInfected() {
        return this.docIsScanned
            && this.requirement.documentInfected;
    }

    get docIsClean() {
        return this.docIsScanned
            && !this.requirement.documentInfected;
    }
}
